import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import GlDialogTitle from '../../share/dialog/GlDialogTitle'
import GlDialogBody from '../../share/dialog/GlDialogBody'
import { patchReportService } from '../../../core/api/services/bookmetrie/reports.service'
import { setShowSnackBar } from '../../../store/reducers/web-app.reducer'
import { useAppDispatch } from '../../../store/hooks'
import GlSpinner from '../../share/GlSpinner'
import GlMatInputOutline from '../../share/inputs/GlMatInputOutline'
import { AnalyticsDashboardDialogButton } from './AnalyticsDashboardDialogStyle'

const AnalyticsDashboardRenameDialog = ({
  analyticsId,
  analyticsName,
  handleCancelAction,
  handleReloadAction,
}: {
  analyticsId: string
  analyticsName: string
  handleCancelAction: () => void
  handleReloadAction: () => void
}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [analyticNameInternal, setAnalyticNameInternal] =
    useState<string>(analyticsName)

  const [isLoadingDeleteAction, setIsLoadingDeleteAction] =
    useState<boolean>(false)

  const onClickCancelButton = (event: React.MouseEvent) => {
    event.preventDefault()
    handleCancelAction()
  }

  const onClickRenameButton = (event: React.MouseEvent) => {
    event.preventDefault()
    setIsLoadingDeleteAction(true)

    patchReportService(analyticsId, { name: analyticNameInternal })
      .then(() => {
        dispatch(
          setShowSnackBar(
            t('snackbarMessage.renameReportConfirm', {
              reportName: analyticNameInternal,
            }),
          ),
        )
        handleReloadAction()
        handleCancelAction()
      })
      .catch(() => {
        dispatch(setShowSnackBar(t('snackbarMessage.errorMessage')))
      })
      .finally(() => {
        setIsLoadingDeleteAction(false)
      })
  }

  return (
    <div className="flex flex-col gap-4">
      <GlDialogTitle label={analyticsName} />
      <GlDialogBody>
        <div>{t('webApp.reports.confirmRenameAnalytics')}</div>
        <GlMatInputOutline
          type="text"
          onChangeValue={(value: string) => {
            setAnalyticNameInternal(value)
          }}
          label=""
          value={analyticNameInternal}
          placeholder={t('analyticNamePlaceHolder')}
          hasClearButton
          hasError={!analyticNameInternal}
          hasErrorMessage={t('analyticNameRequired')}
        />
      </GlDialogBody>
      <div className="flex flex-row gap-2">
        <AnalyticsDashboardDialogButton
          className="flex-1"
          onClick={onClickCancelButton}
        >
          {t('commons.buttons.cancel')}
        </AnalyticsDashboardDialogButton>
        <AnalyticsDashboardDialogButton
          className="relative flex-1"
          primary
          onClick={onClickRenameButton}
          disabled={isLoadingDeleteAction}
        >
          {(isLoadingDeleteAction && (
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
              <GlSpinner />
            </div>
          )) ||
            null}
          {t('commons.buttons.rename')}
        </AnalyticsDashboardDialogButton>
      </div>
    </div>
  )
}

export default AnalyticsDashboardRenameDialog
